import { truncateAddress } from '@kwenta/sdk/utils'
import { FC, memo } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { FlexDivCol } from 'components/layout/flex'
import { Body } from 'components/Text'
import { selectSelectedDelegationAddress } from 'state/futures/selectors'
import { useAppSelector } from 'state/hooks'

const NewDelegationHeader: FC = memo(() => {
	const { t } = useTranslation()
	const selectedAddress = useAppSelector(selectSelectedDelegationAddress)

	return (
		<Container rowGap="4px">
			{t('futures.market.trade.margin.modal.delegation.new.modal-title')}
			<WalletAddressLabel color="preview" mono size="xsmall">
				{truncateAddress(selectedAddress)}
			</WalletAddressLabel>
		</Container>
	)
})

const Container = styled(FlexDivCol)`
	margin-top: 20px;
`

const WalletAddressLabel = styled(Body)`
	line-height: 1;
	text-transform: none;
`

export default NewDelegationHeader
